import { signedUploadUrl, uploadFileToS3 } from "../api/fileStorage";
import { FileStorageS10Data, PresignedFiles } from "../interfaces/fileStorage.interface";
import { store } from "../reducers";
import { v4 as uuidv4 } from 'uuid';


export const buildMediaUrl = (filePath: string | string[]): string => {
    const finalPath = typeof filePath === 'object' ? filePath[0] : filePath;
    
    return `${process.env.REACT_APP_MEDIA_FILES_URL}${finalPath}`
}

interface FileWeight {
    sizeInKb: number;
    sizeInMb: number;
    sizeLabel: string;
}

export const getFileWeight = (fileData: File): FileWeight => {
    const sizeInKb = Number((fileData.size / 1024).toFixed(1));
    const sizeInMb = Number((fileData.size / (1024 * 1024)).toFixed(1));
    const sizeLabel = sizeInMb <= 0
        ? ` ${sizeInKb} kb`
        : ` ${sizeInMb} Mb`;
    return {
        sizeInKb,
        sizeInMb,
        sizeLabel
    }
}

export interface UploadFilesToFilesStorageResult {
    groupId: string;
    filestorageData: FileStorageS10Data[];
    fileS3Urls: string[];
}

export interface MyFile extends File {
    fileId?: string;
}

export const uploadFilesToFilestorage = async (
    files: MyFile[], 
    setErrorMsg: (error: string) => void,
    isDeletable: boolean,
    groupId = uuidv4(),
    useDate = true,
    filesId: string[] = [],
): Promise<UploadFilesToFilesStorageResult | null> => {
    const companyselected = store.getState().auth.companyselected;
    if (!companyselected) {
        console.error("companyselected", companyselected)
        setErrorMsg("Ocurrio un error, por favor reintenta.")
        return null;
    }
    const mediaUrls: PresignedFiles[] = [];
    const filestorageData: FileStorageS10Data[] = [];
    for (let i = 0; i < files.length; i++) {
        const fileExtension = files[i].name.split(".").slice(-1)[0];
        const fileId = filesId.length && filesId[i] ? filesId[i] : uuidv4();
        mediaUrls.push({
            isDeletable,
            fileId: `${fileId}`,
            extension: fileExtension,
            useDate,
            "Content-Type": files[i].type,
        });
        
    }
    const result = await signedUploadUrl({
        ruc: companyselected.RUC,
        files: mediaUrls,
    });
    if (!result || result.Type !== 0 || result.Value.errors?.length) {
        console.error(result);
        const msg = !result 
                    ? "Error de conexión, por favor reintenta."
                    : result.Type !== 0
                        ? result.Message
                        : result.Value.errors.map(e => e.file_errors).join("\n")
        setErrorMsg(msg)
        return null;
    }
    const presignedUrls = result.Value.presigned_urls;
    const promises: Promise<boolean>[] = []
    const fileS3Urls: string[] = []
    for (let index = 0; index < files.length; index++) {
        const presignedData = presignedUrls[index].presigned_data;
        console.log("presignedData.fields.key", presignedData.fields.key)
        fileS3Urls.push(presignedData.fields.key)
        promises.push(uploadFileToS3(files[index], presignedData))
        filestorageData.push({
            Id: presignedUrls[index].fileId,
            Extention: presignedUrls[index].extension,
            Date: presignedUrls[index].datetime as any,
            FileName: files[index].name,
            Base64Prefix: "",    
            Group: groupId,    
            Description: "",    
            CustomFlag: "",    
            Folder: "",    
            IsDeleteable: isDeletable,
            RUCCorporation: companyselected.RUC,    
            InS3: true
        })
    }
    const uploadResult = await Promise.all(promises);
    if (uploadResult.filter(r => r === false).length) {
        console.log(uploadResult)
        setErrorMsg("Error subiendo los archivos a la nube.")
        return null;
    }
    return {groupId, filestorageData, fileS3Urls};
}

export const resizeImage = async(file: File): Promise<MyFile[]> => {
    const fileType = file.type;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = (event: ProgressEvent<FileReader>) => {
        const img = new Image();
  
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
  
          const sizes = [
            { width: 80, height: 80, name: 'small' }, 
            { width: 550, height: 550, name: 'medium' },
            { width: 1200, height: 800, name: 'large' },
          ];
  
        //   const resizedFiles: { [key: string]: File } = {};
          const resizedFiles: File[] = [];
  
          Promise.all(
            sizes.map(size => {
              return new Promise<void>(resolveSize => {
                if (ctx) {
                  canvas.width = size.width;
                  canvas.height = size.height;
                  ctx.drawImage(img, 0, 0, size.width, size.height);
  
                  canvas.toBlob(blob => {
                    if (blob) {
                      const resizedFile = new File([blob], `${size.name.toUpperCase()}.jpeg`, { type: 'image/jpeg' });
                      resizedFiles.push(resizedFile);
                    //   resizedFiles[size.name] = resizedFile;
                      resolveSize();
                    } else {
                      reject(new Error('Error al crear el blob de la imagen.'));
                    }
                  }, fileType);
                } else {
                  reject(new Error('Error al obtener el contexto del canvas.'));
                }
              });
            })
          ).then(() => {
            resolve(resizedFiles);
          });
        };
  
        img.src = event.target?.result as string;
      };
  
      reader.readAsDataURL(file);
    });
}